// @ts-nocheck
/* eslint-disable */
export const correctIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 14"><path fill="currentColor" d="M3.948 13.616h-.63l-1.75-3.08-.91.532-.392-.658 2.002-1.176 1.596 2.828L9.898.834h.938z"/></svg>`,
    name: 'correct' as const
};